import { IGlobalConfigurationState } from 'store/GlobalConfigurationSlice/GlobalConfigurationSliceModels'

export interface ConsentListItem {
   id: number;
   isRequired: boolean;
   text: string;
   title: string | null;
   textWithoutHtml: string | null;
   isActive: boolean;
   isSummary?: boolean;
}

export interface ConsentFetchModel {
   list: ConsentListItem[]
}

export interface IAppConsentsModel {
   consentId: number;
   isRequired: boolean;
   text: string;
   title: string;
   isActive: boolean;
   hasError: boolean;
   isChecked: boolean;
}

export interface IAppConsentsModelToSend {
   id: number;
   text: string;
   isConsent: boolean;
}

export interface IGlobalConfigurationFetchModel {
   data: IGlobalConfigurationState;
}

export enum ConsentType{
   Standard = 0,
   Retention = 1
}